import { Brand, Type } from '@lendi/lala-react';

type BrandIndex = Record<Brand, string>;

const brandPhonebook: BrandIndex = {
  [Brand.Lendi]: '1300 323 181',
  [Brand.Aussie]: '13 13 33',
};

const brandChatLinkIndex: BrandIndex = {
  [Brand.Lendi]: 'https://www.lendi.com.au/?openChatWindow=1',
  [Brand.Aussie]: '',
};

export const getBrandPhoneNumber = (brand: Brand) => brandPhonebook[brand];
export const getBrandPhoneNumberForTel = (brand: Brand) => getBrandPhoneNumber(brand).replace(/ /g, '');
export const getBrandChatLink = (brand: Brand) => brandChatLinkIndex[brand];

export const mapBrandToPath = (brand: Brand, type: Type) => {
  if (brand === Brand.Aussie && type === Type.Customer) {
    return process.env.REACT_APP_AUSSIE_ROUTE_PATH;
  }
  return process.env.REACT_APP_LENDI_ROUTE_PATH;
};
